import { useContext } from 'react';
import { UserContext } from '@/contexts/UserContext';
import * as ROUTES from '@/constants/routes';

/**
 * @typedef {Object} TariffRoutes
 * @property {(tariff_id: string) => string} editPath Where Create, Duplicate and Edit open the editor.
 * @property {string} exitPath Where the editor returns after Save, Delete, or a tariff it can't edit.
 */

/** @type {TariffRoutes} */
export const ACCOUNT_TARIFF_ROUTES = {
    editPath: (tariff_id) => ROUTES.ACCOUNT_TARIFFS.replace(':tariff_id', tariff_id),
    exitPath: ROUTES.ACCOUNT,
};

/**
 * The tariff editor's routes for the current context. The corporate shipper page sets
 * `tariffRoutes` on UserContext so the editor opens, and returns, inside the shipper's context.
 * @returns {TariffRoutes}
 */
export const useTariffRoutes = () => useContext(UserContext)?.tariffRoutes || ACCOUNT_TARIFF_ROUTES;
